"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _matchFirstNumber = _interopRequireDefault(require("./matchFirstNumber"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var twoDecimalPlaces = function twoDecimalPlaces(data) {
  return (0, _matchFirstNumber.default)(data).toFixed(2);
};
var _default = exports.default = twoDecimalPlaces;